import React from 'react'
import PropTypes from 'prop-types'
import { MenuGroup, MenuItem, createToast } from '@maui/elements'
import { useAuthProvider } from './useAuthProvider'

const OrgsList = ({ orgs, returnTo: propsReturnTo }) => {
  const { api, selectedOrg } = useAuthProvider()

  const handleOrgSwitch = orgOverride => {
    const returnTo = typeof propsReturnTo === 'function'
      ? propsReturnTo(orgOverride)
      : typeof propsReturnTo === 'string'
        ? propsReturnTo
        : location.pathname + location.search

    const state = { returnTo }

    return () => {
      try {
        api.initiateLogin({ orgOverride, state })
      } catch (error) {
        createToast({
          variant: 'error',
          message: 'Unable to switch organizations. Please try again later.',
        })
      }
    }
  }

  return (
    <MenuGroup label="Organizations">
      {orgs?.length === 0 &&
        <MenuItem disabled>No Matches Found</MenuItem>
      }
      {orgs?.map(org => {
        const selected = org.uuid === selectedOrg.uuid

        return (
          <MenuItem
            key={org.uuid}
            title={org.name}
            onClick={selected ? undefined : handleOrgSwitch(org.uuid)}
            disabled={selected}
          >
            {org.name}
          </MenuItem>
        )
      })}
    </MenuGroup>
  )
}

OrgsList.propTypes = {
  orgs: PropTypes.array,
  returnTo: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
}

export { OrgsList }
